<template>
    <div class="notifications-container" v-on:click="handleBellClick()">
      <div class="bell-and-number">
          <i class="fa fa-regular fa-bell fa-xl" ></i>
          <div class="number-notifications-container">
              <h6 class="number-notifications" v-if="this.friendRequests.length > 0 || notifications.length > 0">{{ this.friendRequests.length + notifications.length }}</h6>
          </div>
      </div>
    </div>
  </template>

  <script>

  import FriendRequestService from '@/services/FriendRequestService';
  import NotificationsService from '@/services/NotificationsService';
  import ArticleDataService from '@/services/ArticleDataService';

  export default {
      name: "notification-bell",
      data() {
          return {
              friendRequests: [],
              notifications: [],
              currentUser: 0,
          }
      },
      async mounted(){
    try {
        // Fetch friend requests
        const friendRequestsResponse = await FriendRequestService.listFriendRequsts();
        this.friendRequests = friendRequestsResponse.data;

        // Fetch current user
        const userResponse = await ArticleDataService.getUser();
        this.currentUser = userResponse.data;

        // Fetch notifications only if currentUser is not 0
        if (this.currentUser !== 0) {
            const notificationsResponse = await NotificationsService.getNotifications();
            this.notifications = notificationsResponse.data;
        }
    } catch (error) {
        if (error !== 'User not authenticated') {
          console.error("Error fetching data:", error);
        }
    }
},
      methods: {
        handleBellClick() {
            this.$router.push('/notifications');
        }
      }
  }
  </script>
  
  <style scoped>
/* General Styles */
p {
  padding: 1px;
  margin: 0px;
  color: black;
}

.notifications-container {
  display: flex;
  flex-direction: column;
  position: relative;
  width: fit-content;
  cursor: pointer;
}

.bell-and-number {
  display: flex;
  align-items: center;
  position: relative;
}

.number-notifications-container {
  position: absolute;
  bottom: -43px; 
  right: -19px; 
}

@media (min-width: 1000px) and (max-width: 1200px){
  .number-notifications-container {
    bottom: -48px;
  }
}

.number-notifications {
  height: min-content;
  width: max-content;
  padding: 5px 10px;
  z-index: 2;
  background-color: red;
  color: #fff;
  border-radius: 50%;
  font-size: 0.5em;
}
</style>
  